module.exports = __webpack_public_path__ + "static/img/4.f752db01.jpg";